import md5 from 'md5'

/**
 * Generate a Gravatar URL from an email address
 * @param email - The email address
 * @param options - Optional parameters for the Gravatar URL
 * @returns The Gravatar URL
 */
export function getGravatarUrl(
  email: string,
  options: {
    size?: number
    default?:
      | 'identicon'
      | 'monsterid'
      | 'wavatar'
      | 'retro'
      | 'robohash'
      | 'blank'
      | '404'
  } = {},
): string {
  const { size = 80, default: defaultImage = 'identicon' } = options

  // Normalize email: trim and lowercase
  const normalizedEmail = email.trim().toLowerCase()

  // Create MD5 hash
  const hash = md5(normalizedEmail)

  return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=${defaultImage}`
}
